<template>
    <div>
        <h2>{{ $t("wp.purchaseHeader") }}</h2>
        <span> {{ $t("wp.purchasePaymentDescription") }}</span>
        <div class="plans mt-5">
            <div :class="{ selected: true }" class="plan">
                <div class="header">{{ $t("wp.wpIntegrationFeatures") }}</div>
                <div class="plan-price-section">
                    <div class="plan-price-details">
                        <span :class="{ tl: site.basePrice.currency === 'tl' }" class="amount">{{
                            $_.get(site, "whatsappBasePrice.value", 250)
                        }}</span>
                        <i
                            ><i class="slash">/</i>
                            <i class="billed-month"
                                >{{ $t("billing.month") }}
                                <i class="billed-yearly hide"><br />{{ $t("billing.billedMonthToMonth") }}</i></i
                            ></i
                        >
                    </div>
                </div>
                <md-button
                    :disabled="wpInfo.initialized && wpInfo.status.purchased"
                    class="md-raised md-primary w-100"
                    style="transform: scale(0.7); font-size: x-large; border-radius: 10%"
                    @click="updateIntegration('whatsapp', true)"
                    >{{ $t(wpInfo.initialized && wpInfo.status.purchased ? "wp.subscribed" : "wp.subscribe") }}
                </md-button>
                <span class="text-succes">-</span>
                <a-divider>{{ $t("wp.planDetails") }}</a-divider>
                <div class="features">
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("wp.sendReceiveMessage") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("wp.sendReceiveImage") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("wp.sendReceiveAudio") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("wp.sendReceiveGif") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("wp.startChat") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("wp.supsisFunctionality") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("wp.onePhoneMultiAgent") }}</span>
                    </div>
                    <div class="feature">
                        <a-icon type="check" />
                        <span>{{ $t("wp.basicIntegration") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { updateIntegration } from "../../api/billing";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { sendSocketMessage } from "../../utils/socketStream";

export default {
    name: "Purchase",
    props: {
        purchaseCompleted: {
            type: Function,
            default: () => {},
        },
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            siteId: (state) => state.site.site._id,
            site: (state) => state.site.site,
            wpInfo: (state) => state.whatsapp.info,
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
        }),
        ...mapMutations({
            changePurchaseStatus: "whatsapp/changePurchaseStatus",
        }),
        async updateIntegration(key, status = false) {
            await updateIntegration(this.siteId, key, status);
            this.changePurchaseStatus(status);
            this.getSettings();
            this.purchaseCompleted();
            sendSocketMessage("user settings-updated", {
                siteId: this.siteId,
            });
            sendSocketMessage("user wp-purchase-event", {
                siteId: this.siteId,
            });
        },
    },
};
</script>
